import {ensureSlug} from "../../utils/validation/ensureSlug";

import {createWorkspace as createWorkspaceGQL} from "../../graphql/mutations";
import {queryGqlApi} from "../../graphql/queryGqlApi";
import {IDataClientService} from "../../platform/services/data/DataClientService";
import {IAuthService} from "../../platform/services/auth/AuthService";
import {UserSessionState} from "@stores/UserSessionState";


export async function createWorkspace(
    dataClientService: IDataClientService,
    authService: IAuthService,
    userState: UserSessionState,
    name: string
) {
    const queryResult = await queryGqlApi(
        createWorkspaceGQL,
        {
            input: {
                name: name,
                slug: await ensureSlug(name),
                ownerId: userState.tenantId,
                childIds: JSON.stringify([]),
                trashedIds: JSON.stringify([]),
                archivedIds: JSON.stringify([]),
                updatedAt: (new Date()).toISOString(),
            }
        },
        dataClientService,
        authService,
        'main'
    );
    return queryResult;
}
